import { render, staticRenderFns } from "./QLogoCard.vue?vue&type=template&id=66c2aaf4&scoped=true"
import script from "./QLogoCard.vue?vue&type=script&lang=js"
export * from "./QLogoCard.vue?vue&type=script&lang=js"
import style0 from "./QLogoCard.vue?vue&type=style&index=0&id=66c2aaf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2aaf4",
  null
  
)

export default component.exports